import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import deTranslation from '../assets/translations/de.json';
import frTranslation from '../assets/translations/fr.json';

export type SupportedLanguage = 'de' | 'fr';

interface TranslationResources {
  [key: string]: {
    translation: Record<string, any>;
  };
}

const resources: TranslationResources = {
  de: {
    translation: deTranslation,
  },
  fr: {
    translation: frTranslation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de' as SupportedLanguage, // Default language
    fallbackLng: 'de' as SupportedLanguage,
    debug: false, // Set to true for development

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;